import * as React from 'react';
import { useTranslation } from 'next-i18next';
import Head from 'next/head';
import { defaultGetStaticProps } from 'utils/staticPropsHelper';
import { getHeaderTitle } from 'utils/string';
import BecomePartnerContainer from 'containers/BecomePartner';
import { CONTENTFUL_ASSET, getAsssetByTitle } from 'utils/contentful/asset';
import { GetStaticPropsContext } from 'next';
import { DEFAULT_LANG } from 'utils/lang';
import { ContentfulAsset } from 'model/contentful/asset';

interface Props {
  heroImage: ContentfulAsset;
}

const BecomePartner: React.FC<Props> = ({ heroImage }) => {
  const { t } = useTranslation();

  return (
    <div className="BecomePartnerPage">
      <Head>
        <title>{getHeaderTitle(t('becomePartner.meta.title') as string)}</title>
      </Head>
      <BecomePartnerContainer heroImage={heroImage} />
    </div>
  );
};

export const getStaticProps = async (context: GetStaticPropsContext) => {
  const { preview } = context;
  const { props } = await defaultGetStaticProps(context);

  let heroImage;

  try {
    heroImage = await getAsssetByTitle(CONTENTFUL_ASSET.BECOME_PARTNER, preview, DEFAULT_LANG);
  } catch (e: any) {
    console.error('Error fetching contentful data: ', e);
  }
  return {
    props: {
      ...props,
      heroImage: heroImage || null
    },
    revalidate: 10
  };
};

export default BecomePartner;
